import toast from '../components/toast/toast';

export default {
  /**
   * Find all store actions with `socket_` prefix and register listeners.
   * Then bind `$socket` client to to Vue.
   */
  install(app) {
    /* eslint-disable no-param-reassign */

    // The correct way via provide/inject
    app.provide('successToast', (text) => {
      toast.makeToast({ text });
    });

    app.provide('errorToast', (text) => {
      toast.makeToast({
        heading: 'Error',
        icon: 'error',
        loaderBg: 'red',
        text,
      });
    });

    // Evan You doesn't like this, but until we properly use provide/inject...
    app.config.globalProperties.successToast = (text) => toast.makeToast({ text });
    app.config.globalProperties.errorToast = (text) => toast.makeToast({
      heading: 'Error',
      icon: 'error',
      loaderBg: 'red',
      text,
    });
  },
};
